import DataTable from "@shared/ui/data-table/DataTable";
import { Skeleton } from "@mui/material";
import { useTheme } from "@emotion/react";
import { StyledCashBoxes } from "./cashBoxes.styled";
import { useCashBoxOptions } from "./cashBoxes.data";
import { useCashBoxStructures } from "./useCashBoxStructures";
import { useCashBoxesBrowse } from "./useCashBoxesBrowse";
import { useCashBoxesNavigation } from "./useCashBoxesNavigation";

function CashBoxes() {
  const theme = useTheme();
  const { tableStructure } = useCashBoxStructures();
  const browse = useCashBoxesBrowse();
  const navigation = useCashBoxesNavigation();
  const cashBoxOptions = useCashBoxOptions();

  const skeletonSx = { bgcolor: theme.colors.section_color };

  return (
    <StyledCashBoxes>
      {tableStructure ? (
        <DataTable
          structure={tableStructure}
          searchForm={browse.accountSearchForm}
          onResetSearch={browse.reset}
          sortKey={browse.sortKey}
          setStructure={navigation.editBrowseStructure}
          setSortKey={browse.handleSortKeyChanged}
          sortMethod={browse.sortMethod}
          setSortMethod={browse.handleSortMethodChanged}
          data={browse.data}
          isLoading={browse.isLoading}
          options={cashBoxOptions}
          selectRow={navigation.selectRow}
          onSelectRow={navigation.rowChosen}
          pagination={{
            page: browse.page,
            perPage: browse.perPage,
            hasNextPage: browse.hasNextPage,
            hasPrevPage: browse.hasPrevPage,
            onNextPage: browse.handleNextPage,
            onPrevPage: browse.handlePrevPage,
            onRowsPerPageChange: browse.handleRowsPerPageChange,
          }}
        />
      ) : (
        <Skeleton variant="rectangular" height={150} animation="wave" sx={skeletonSx} />
      )}
    </StyledCashBoxes>
  );
}

export default CashBoxes;
